import React from "react";
import { Rocket, Star, Cat, Dog, Bird, Fish, Ghost, Sun } from "lucide-react";

export const AVATARS = [
  { key: "rocket", Icon: Rocket, color: "#0D9488" },
  { key: "star", Icon: Star, color: "#F59E0B" },
  { key: "cat", Icon: Cat, color: "#E05A47" },
  { key: "dog", Icon: Dog, color: "#0284C7" },
  { key: "bird", Icon: Bird, color: "#10B981" },
  { key: "fish", Icon: Fish, color: "#7A3FF2" },
  { key: "ghost", Icon: Ghost, color: "#DB2777" },
  { key: "sun", Icon: Sun, color: "#D97706" },
];

export const avatarByKey = (key) =>
  AVATARS.find((a) => a.key === key) || AVATARS[0];

export function AvatarBadge({ avatarKey, size = 44, className = "" }) {
  const a = avatarByKey(avatarKey);
  const { Icon } = a;
  return (
    <div
      className={`flex items-center justify-center rounded-2xl shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        background: `${a.color}1A`,
        border: `2px solid ${a.color}`,
      }}
    >
      <Icon size={size * 0.5} strokeWidth={2.4} color={a.color} />
    </div>
  );
}
